export default "__VITE_ASSET__2920b014__"